import {ModuleWithProviders} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {HomeComponent} from './home/home.component';
import {ContactComponent} from './contact/contact.component';
import {NotFoundComponent} from './not-found/not-found.component';
import {ImprintComponent} from './imprint/imprint.component';
import {DisclaimerComponent} from './disclaimer/disclaimer.component';
import {RequirementsComponent} from './requirements/requirements.component';

const appRoutes: Routes = [
    {path: '', component: HomeComponent},
    {path: 'contact', component: ContactComponent},
    {path: 'imprint', component: ImprintComponent},
    {path: 'disclaimer', component: DisclaimerComponent},
    {path: 'requirements', component: RequirementsComponent},
    {path: '**', component: NotFoundComponent}
];

export const appRouting: ModuleWithProviders = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// /media/webdesign/5E0ECC7B0ECC4E29/www/leasytool/src/app/app.routing.ts